"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invisible = void 0;
var invisible_1 = require("./invisible");
Object.defineProperty(exports, "Invisible", { enumerable: true, get: function () { return __importDefault(invisible_1).default; } });
//# sourceMappingURL=index.js.map